import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFCopyIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 2.5C8.89543 2.5 8 3.39543 8 4.5V14.5C8 15.6046 8.89543 16.5 10 16.5H16C17.1046 16.5 18 15.6046 18 14.5V4.5C18 3.39543 17.1046 2.5 16 2.5H10ZM9 4.5C9 3.94772 9.44772 3.5 10 3.5H16C16.5523 3.5 17 3.94772 17 4.5V14.5C17 15.0523 16.5523 15.5 16 15.5H10C9.44772 15.5 9 15.0523 9 14.5V4.5ZM6 6.50001C6 5.75973 6.4022 5.11339 7 4.76758V15C7 16.3807 8.11929 17.5 9.5 17.5H15.7324C15.3866 18.0978 14.7403 18.5 14 18.5H9.5C7.567 18.5 6 16.933 6 15V6.50001Z'
        fill={fill}
      />
    </svg>
  )
}
